module.exports = __webpack_public_path__ + "img/Vector3.7ef47399.svg";